export default function getDiscountReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GETS_DISCOUNT_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GETS_DISCOUNT_ERROR':
            return {...state, ...{error: action.error}};

        case 'GETS_DISCOUNT_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}